// TipCard configuration and state management types

export type TipCardPlacementMode = 'first-in-section' | 'listed-flow';
export type TipCardSection = 'destaque' | 'para_voce' | 'outros';
export type TipCardType = 'standard' | 'banner';

export interface TipCardConfig {
  id: string;
  type: TipCardType;
  enabled: boolean;
  placementMode: TipCardPlacementMode;
  
  // For "first-in-section" mode
  section?: TipCardSection;
  
  // For "listed-flow" mode
  listOrder?: number; // 1, 2, 3, etc. — prioridade de alocação nos slots
  // Restringe o tip a uma seção específica no fluxo. Se omitido, o tip pode
  // aparecer em qualquer seção do fluxo (Para você ou Outros), nunca no Express.
  listedSection?: Extract<TipCardSection, 'para_voce' | 'outros'>;
  
  // Content
  title?: string;
  text: string;
  ctaLabel: string;
  ctaLink?: string; // Optional link for banner cards
  
  // Standard tip styling
  icon?: string;
  backgroundColorToken?: string;
  iconBgColorToken?: string;
  iconColorToken?: string;
  
  // Banner tip styling
  bannerImageUrl?: string;
  bannerOverlayOpacity?: number; // 0.4 - 0.6
  
  // Behavior
  isDismissible: boolean;
}

export interface TipCardState {
  [tipId: string]: {
    dismissed: boolean;
  };
}

// Default TipCard configurations
export const defaultTipCardConfigs: TipCardConfig[] = [
  // --- Posição "Primeiro" (first-in-section) ---
  {
    id: 'express',
    type: 'standard',
    enabled: true,
    placementMode: 'first-in-section',
    section: 'destaque',
    text: 'Clientes Express pagaram para aparecer aqui, indicando alto interesse de contratar um profissional.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#7c3aed',
    iconBgColorToken: '#6d28d9',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'para-voce',
    type: 'standard',
    enabled: true,
    placementMode: 'first-in-section',
    section: 'para_voce',
    text: '"Para você" são pedidos recomendados a partir do seu histórico de liberações e avaliações.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#059669',
    iconBgColorToken: '#047857',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  // --- Posição "Não primeiro" (listed-flow) ---
  {
    id: 'no-competition',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 1,
    text: 'Liberar pedidos que ninguém liberou ainda aumentam suas chances de fechar negócio!',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'rate-orders',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 2,
    listedSection: 'para_voce',
    text: 'Avaliando os pedidos, você melhora a recomendação de pedidos para você.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'profile-updated',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 3,
    text: 'Clientes veem sua avaliação e comentários. Mantenha seu perfil atualizado!',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'send-message',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 4,
    text: 'Sempre envie uma mensagem se apresentando com link do seu perfil, isso gera confiança e aumenta as chances do cliente responder.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'more-orders',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 5,
    text: 'Quanto mais pedidos você liberar, maiores as chances de fechar um serviço e ter retorno do investimento.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
];